import type { Page, Reference } from '@ps/web-martech-cms-types';
import { useResolver } from '@ps/web-shared-components';
import React from 'react';

import { useCMSReference } from '@swf/cms';
import StarsNavigationItem from '@swf/components/StarsNavigation/StarsNavigationItem';

interface Props {
  pageRef?: Reference[];
  heading?: string;
  url?: string;
  resolverTag?: string;
  onClick?(): void;
}

const SubmenuItem: React.FC<Props> = ({ pageRef, heading, url, resolverTag, onClick }) => {
  const page = useCMSReference<Page>(pageRef?.[0]);
  const resolverLink = useResolver(resolverTag);
  const href = url || resolverLink || page?.url;

  return (
    <StarsNavigationItem href={href} onClick={onClick} active={false}>
      {heading}
    </StarsNavigationItem>
  );
};

export default SubmenuItem;
